export enum AdditionalJourneysType {
    LegacyJourneys = 'LegacyJourneys'
}
